export class AuthError extends Error {
  constructor() {
    super()
    this.message = 'Not authorized to access this resource'
  }
}
